import type { ReactNode } from "react";
import { memo } from "react";
import {
  Link,
  useLocation,
  useNavigation,
  useSearchParams,
} from "react-router";

import { LoadingButton } from "~/components/ui/loading-button";
import { cn } from "~/lib/ui";

export const LoadMore = memo(
  ({
    page,
    data,
    className,
    children,
    coordinates,
  }: {
    page?: number;
    data?: unknown;
    className?: string;
    children?: ReactNode;
    coordinates?:
      | {
          lat: number;
          lng: number;
        }
      | undefined;
  }) => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const currentPage = page || parseInt(searchParams.get("page") ?? "0");
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set("page", (currentPage + 1).toString());
    const nav = useNavigation();
    const isLoading =
      nav.state !== "idle" && nav.location.pathname.includes("/shop");
    if (coordinates) {
      newSearchParams.set("lat", coordinates.lat.toString());
      newSearchParams.set("lng", coordinates.lng.toString());
    }
    return (
      <div className="flex w-full flex-col items-center justify-center self-center">
        <div className={cn("p-3 text-base", className)}>{children}</div>

        <LoadingButton
          as={Link}
          to={`${location.pathname}?${newSearchParams.toString()}`}
          prefetch="render"
          preventScrollReset
          state={data}
          className="w-40"
          isLoading={isLoading}
        >
          <span>Load more...</span>
        </LoadingButton>
      </div>
    );
  },
);

LoadMore.displayName = "LoadMore";
